import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './components/App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
// import reportWebVitals from './reportWebVitals';
import {BrowserRouter} from "react-router-dom";
import {ToastContainer} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import './assets/styles/global.scss';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <BrowserRouter>
        <App/>
        <ToastContainer
            position="top-right"
            closeButton={false}
            closeOnClick
            rtl
            style={{fontFamily: "Shabnam"}}
            draggable
            pauseOnHover={false}
            autoClose={3000}/>
    </BrowserRouter>
);

serviceWorkerRegistration.unregister();
// reportWebVitals();
